import { render } from "./News_page_m.vue?vue&type=template&id=3a0fbacb&scoped=true"
import script from "./News_page_m.vue?vue&type=script&lang=js"
export * from "./News_page_m.vue?vue&type=script&lang=js"

import "./News_page_m.vue?vue&type=style&index=0&id=3a0fbacb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3a0fbacb"

export default script